export class ProtestosFichasModel {
  id_protesto: number;
  protesto_pt: string;
  protesto_en: string;
  protesto_es: string;
}



// WEBPACK FOOTER //
// ./src/app/protestos-fichas/protestos-fichas.model.ts